import { useState, useRef, useEffect } from 'react'
import { Chip } from '@mui/material'
import VolumeOffIcon from '@mui/icons-material/VolumeOff'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import ProfileCard from '../../components/videopage/profile/ProfileCard'


export function VibioPageMobile({ videoSrc, socials, linkButtons, userData, theme, onLinkClick }) {
    const [isMuted, setMuted] = useState(true)
    const [videoError, setVideoError] = useState(false)
    const videoRef = useRef(null)

    const handleMute = () => setMuted(!isMuted)

    // A new videoSrc (e.g. after re-upload) clears any prior load error so playback is re-attempted.
    useEffect(() => setVideoError(false), [videoSrc])

    useEffect(() => {
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'auto'
        })
    }, [])

    const styles = {
        container: {
            position: 'relative',
            height: '100vh',
            width: '100%',
            overflow: 'hidden'
        },
        muteToggle: {
            m: 0,
            p: 0,
            position: 'absolute',
            top: '16px',
            right: '16px',
            zIndex: 1,
            color: '#fff',
            backgroundColor: 'transparent',
            '& .MuiChip-icon': {
                color: 'primary.bg',
            }
        },
        video: {
            width: '100%',
            height: '100vh',
            objectFit: 'cover'
        }
    }

    return (
        <div style={styles.container}>
            {!videoError ? (
                <>
                    <Chip
                        onClick={handleMute}
                        icon={isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
                        sx={styles.muteToggle}
                    />
                    <video
                        preload="auto"
                        style={styles.video}
                        src={videoSrc}
                        ref={videoRef}
                        muted={isMuted}
                        playsInline
                        autoPlay
                        loop
                        onClick={handleMute}
                        onError={() => setVideoError(true)}
                    />
                </>
            ) : (
                <img
                    src={videoSrc}
                    alt=""
                    style={styles.video}
                />
            )}
            <ProfileCard
                socials={socials}
                linkButtons={linkButtons}
                userData={userData}
                theme={theme}
                onLinkClick={onLinkClick}
            />
        </div>
    )
}
